import React from 'react';

function Logo(props: any) {
  return <img alt="Logo" height={42} src="/logo.svg" {...props} />;
}

export default Logo;
